module.exports = __webpack_public_path__ + "media/images/flags/fk-ddc6bd174c1e6603e32352cbbb63f3fb.svg";